<nz-alert
  nzType="info"
  [nzMessage]="'LOT_BIDDING_MODAL.MAX_BID_AMOUNT_LIMIT' | translate: { amount: maxAmount | number }"
></nz-alert>
